import { atom } from "jotai";

export const isUploadingAtom = atom<boolean>(false);
